export default __webpack_public_path__ + "static/media/turkish_flag2.21c34d22.jpg";